import React from "react";
import { Moon, Sun, Laptop } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface Props {
  /** Visar text bredvid ikonen (används i mobilmenyn) */
  withLabel?: boolean;
  className?: string;
}

const OPTIONS = [
  { value: "light", label: "Ljust läge", icon: Sun },
  { value: "dark", label: "Mörkt läge", icon: Moon },
  { value: "system", label: "Följ systemet", icon: Laptop },
] as const;

const ThemeToggle: React.FC<Props> = ({ withLabel = false, className = "" }) => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const current = OPTIONS.find((o) => o.value === theme) ?? OPTIONS[2];
  const ActiveIcon = resolvedTheme === "dark" ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={withLabel ? "sm" : "icon"}
          aria-label={`Byt färgläge (nu: ${current.label})`}
          className={`text-on-hero hover:bg-white/10 ${withLabel ? "w-full justify-start gap-3" : "min-h-11 min-w-11"} ${className}`}
        >
          <ActiveIcon className="h-4 w-4 icon-on-hero" aria-hidden="true" />
          {withLabel && <span>{current.label}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-popover">
        {OPTIONS.map(({ value, label, icon: Icon }) => (
          <DropdownMenuItem
            key={value}
            onSelect={() => setTheme(value)}
            className={`flex items-center gap-2 ${theme === value ? "font-semibold" : ""}`}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
